import { render, staticRenderFns } from "./body-file.vue?vue&type=template&id=6a464c42&scoped=true&"
import script from "./body-file.vue?vue&type=script&lang=js&"
export * from "./body-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a464c42",
  null
  
)

export default component.exports